import { useTimeRangePopulator } from 'hooks';
import usePayPeriodTimeRangeGet from './usePayPeriodTimeRangeGet';

export default function usePayPeriodPopulator() {
  const getter = usePayPeriodTimeRangeGet();
  return useTimeRangePopulator(getter);
}
